import React from "react";

import { Member } from "Models/members/member";
import { useTranslation } from "react-i18next";

import { ResourceIcons } from "../ResourceIcons";
import { PlainText } from "../styles";
import { SubContractorBadge } from "../SubContractorBadge";
import { CardContainer, CardInfosContainer, ImageWrapper } from "./styles";

interface ResourceTeamCardProps {
  teamLeader?: Member | null;
}

export const ResourceTeamLeaderCard: React.FC<ResourceTeamCardProps> = ({ teamLeader }) => {
  const { t: translate } = useTranslation();

  return (
    <CardContainer isActive={!!teamLeader}>
      <ImageWrapper>
        <ResourceIcons name="crown" size={20} />
      </ImageWrapper>

      <CardInfosContainer>
        <PlainText>{teamLeader ? teamLeader.fullName : translate("noLeaderAdded")}</PlainText>

        {!!teamLeader?.subcontractorId && <SubContractorBadge />}
      </CardInfosContainer>
    </CardContainer>
  );
};
